export const MOBILE = '(max-width: 769px)';
